export enum PermissionEnum {
  RecommendationLists = "recommendation_lists",
  RelatorioMix = "relatorio_cobertura_mix",
  feature_flag_test = "feature_flag_test",
  DebugRemoto = "remote_debug"
}
